import { render, staticRenderFns } from "./TestStatistics.vue?vue&type=template&id=0b59424e&scoped=true"
import script from "./TestStatistics.vue?vue&type=script&lang=js"
export * from "./TestStatistics.vue?vue&type=script&lang=js"
import style0 from "./TestStatistics.vue?vue&type=style&index=0&id=0b59424e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59424e",
  null
  
)

export default component.exports